import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { SliderOptions } from '../../../models/sections-model';
import { trigger, transition, group, query, style, animate, keyframes, state } from '@angular/animations';
import { wrapGrid } from 'animate-css-grid';

@Component({
  selector: 'kw-show-slider',
  templateUrl: './show-slider.component.html',
  styleUrls: ['./show-slider.component.scss'],
  animations:[
    trigger('sliderAnimation',[
      state('next',style({transform: '{{slidePosition}}'}),{params:{slidePosition:'translateX(0)'}}),
      state('pause',style({})),
      state('previous',style({transform: '{{slidePosition}}'}),{params:{slidePosition:'translateX(0)'}}),
      transition('* => next',[
        animate('1s 100ms ease-out')
      ]),
      transition('pause => next',[
        animate('1s 100ms ease-out')
      ]),
      transition('pause => *',[
        animate('1s 100ms ease-out')
      ]),
      transition('previous => *',[
        animate('1s 100ms ease-out')
      ]),
      transition('* => *',[
        animate('1s 100ms ease-out')
      ]),
    ])
  ]
})
export class ShowSliderComponent implements OnInit,AfterViewInit{
  @Input() data:SliderOptions;
  @Input() edit:boolean;
  @Input() jumpTo:number;
  showSlides:any[];
  overLayGridContent:any[];
  itemsLength:number;
  actualIndex = 0;
  selectedIndex = 0;
  autoStart = false;
  viewPortWidth:number;
  slideWidth:string;
  numberOfElements:number;
  isPreview:boolean;

  sliderState:string;
  slidePositionNumber = 0;
  slidePosition:string = "transform:translateX(0px)";

  @ViewChild('gridContainer', {read: ElementRef}) gridContainer:ElementRef<HTMLElement>
  @ViewChild('showSliderWrapper', {read: ElementRef}) showSliderWrapper:ElementRef<HTMLElement>;
  constructor(private cdr:ChangeDetectorRef) { }

  ngOnInit(): void {
    console.log(this.data)
    this.showSlides = this.data["rowCells"];
    this.itemsLength = this.showSlides.length;
    this.numberOfElements = this.itemsLength;
    this.overLayGridContent = this.data.overLayGridContent;
    this.isPreview = this.data.isPreview?this.data.isPreview:false;
  }

  get slides() {
    //console.log(this.actualIndex);
    return [this.showSlides[this.actualIndex]];
  }

  ngOnChanges(changes:SimpleChanges):void{
    if(changes['selectedIndex']){
      console.log(this.selectedIndex);
    }
  }

  ngAfterViewInit(): void {
    this.viewPortWidth = this.showSliderWrapper.nativeElement.offsetWidth;
    this.slideWidth = this.viewPortWidth+"px";
    /* wrapGrid(this.gridContainer.nativeElement,{
      duration: 3000,
      stagger: 10,
    })
    this.gridContainer.nativeElement.classList.add('end-state'); */
  }

  updateSelectedIndex(index){
    console.log(index)
    if(index > this.itemsLength-1){
      setTimeout(() => {
        this.sliderState = "pause" 
      }, 100);
      index = 0;
      this.slidePositionNumber = 0;
    }else if(index > this.selectedIndex){
      setTimeout(() => {
        this.sliderState = "pause" 
      }, 100);
      this.sliderState = "next";
      this.slidePositionNumber = this.slidePositionNumber-this.viewPortWidth-8;
    }else{
      this.sliderState = "previous";
      this.slidePositionNumber = this.slidePositionNumber+this.viewPortWidth+8;
      setTimeout(() => {
        this.sliderState = "pause" 
      }, 100);
    }
    this.slidePosition = "translateX("+this.slidePositionNumber+"px)";
    this.selectedIndex = index;
    this.cdr.detectChanges()
  }


}
